import React from 'react'
import Video from '../Video'

export default ({
  autoPlay = true,
  muted = true,
  ...restProps
}) =>
  <Video
    autoPlay={ autoPlay }
    muted={ muted }
    { ...restProps }
  />
